import toArray from 'lodash/toArray';
import get from 'lodash/get';

import getCaseLogicSiblings from '../../utils/getCaseLogicSiblings';

function validateEndConditions(caseConf, { isEffectChain }) {
  if (isEffectChain) {
    return;
  }
  const errors = [];
  const warnings = [];

  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));
  const endNodes = nodes.filter(
    (node) =>
      node.name === 'Effect' && get(node, 'data.effect.type') === 'GAME_END'
  );

  // Win Effect
  if (!endNodes.some((node) => get(node, 'data.effect.value') === true)) {
    warnings.push(caseLogicError('Case does not have a success effect.'));
  }

  // Lose Effect
  if (!endNodes.some((node) => get(node, 'data.effect.value') === false)) {
    warnings.push(caseLogicError('Case does not have a losing effect.'));
  }

  endNodes.forEach((endNode) => {
    const endCaseSiblings = getCaseLogicSiblings(endNode, caseConf.caseLogicDescription);
    endCaseSiblings.forEach(endCaseSiblingNode => {
      warnings.push({
        message:
          'Effects that happen at the same time as End Case will not occur.',
        category: 'caseLogic',
        field: 'caseLogicDescription',
        id: endCaseSiblingNode.id,
        metadata: {
          nodeId: endCaseSiblingNode.id,
        },
      });
    });
  });

  return {
    errors,
    warnings,
  };
}

function caseLogicError(message) {
  return {
    message,
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: null,
    metadata: {
      defaultVisibility: false,
    },
  };
}


export default validateEndConditions;
